/*
 * Project: BookingEngine
 */

import { apiPost } from '../api';

import {
  CART_ERRORS, setCartUpdating, updateCartContent, updateCartErrorCode,
} from './Cart';
import { setCoinsApplied } from './Loyalty';
import { setFilterCurrency } from './Booking';
import { toUseWithAges } from '../utils/Room';

const getAddRoomToBasketRequest = (state, roomOption) => {
  const { hotel, last_requested_info: lastRequest } = state.booking;
  const { filterCurrency } = state.booking;

  return {
    user_currency: filterCurrency.code, // Faltaba enviar el currency code cuando era call center
    code: hotel.code,
    room: {
      checkin: lastRequest.checkin,
      checkout: lastRequest.checkout,
      use: toUseWithAges(hotel, roomOption.room.use_requested), // From { childs, infants } to { childs, ages }
      room: { code: roomOption.room.code },
      rate: { code: roomOption.rate.code },
      board: { code: roomOption.board.code },
      avail_id: roomOption.board.avail_id,
      amount: roomOption.customAmount || null,
    },
  };
};

/* Adds a room to the "free-mode" cart */
export const addFreeModeRoomToCart = (roomOption) => (dispatch, getState) => {
  const state = getState();
  const roomRq = getAddRoomToBasketRequest(state, roomOption);
  return sendBasketUpdateRequest(dispatch, 'add', state, roomRq);
};

/* Removes a room from the "free-mode" cart */
export const removeFreeModeRoom = (cartId) => (dispatch, getState) => {
  const state = getState();
  const removeBody = {
    hotel_code: state.cart.cartHotel.code,
    unique_id: cartId,
  };
  return sendBasketUpdateRequest(dispatch, 'delete', state, removeBody);
};

// Call the API to delete the customer selected extra in his session.
export const removeFreeModeExtra = (data) => (dispatch, getState) => {
  dispatch(setCartUpdating(true));
  const state = getState();
  const { sessionId } = state.bookingFormState;
  const body = {
    room_uuid: data.roomCartId,
    extra_uuid: data.extraUuId,
  };
  return apiPost(`api-pb/shopping-cart/extra/remove-room-extra/${sessionId}/`, body).then((response) => {
    if (!response.success) {
      dispatch(updateCartErrorCode(CART_ERRORS.REMOVE_FREEMODE_EXTRA));
      dispatch(setCartUpdating(false));
      return;
    }
    // When no error happens, we update the cart and associated extras
    dispatch(updateCartContent(response.scart));
    dispatch(setCartUpdating(false));
    dispatch(setCoinsApplied(state.loyalty.coinsApplied));
    // Mandamos a llamar a redeemCoins porque usamos los elementos del shopping cart para calcular
    // el loyalty_new_member_discount_to_apply
  });
};

const sendBasketUpdateRequest = (dispatch, cartAction, state, body) => {
  const { sessionId } = state.bookingFormState;
  const { lang } = state.i18nState;
  dispatch(setCartUpdating(true));

  return apiPost(`api-pb/shopping-cart/room/${cartAction}/${sessionId}/`, body, lang).then((response) => {
    dispatch(setCartUpdating(false));

    const success = (cartAction === 'add' && response.error_code === '00') || response.scart;
    if (success) {
      // If the response is OK, we can take the new basket content to update the cart
      dispatch(updateCartContent(response.scart));

      // If has custom currency rate, select it
      const { custom_currency_code } = response.scart;
      const { currencies } = state.booking;
      const currency = currencies.find((element) => element.code === custom_currency_code);
      if (currency) {
        dispatch(setFilterCurrency(currency));
      }
    } else {
      // We now update the error code
      dispatch(updateCartErrorCode(mapScartErrorCode(response.error_code)));
    }
    return success;
  }).catch(() => {
    const errorCode = cartAction === 'add' ? CART_ERRORS.ADD_FREEMODE_ROOM : CART_ERRORS.REMOVE_FREEMODE_ROOM;
    dispatch(updateCartErrorCode(errorCode));
    return false;
  });
};

const mapScartErrorCode = (apiError) => {
  switch (apiError) {
    case '03':
      return CART_ERRORS.MAX_ROOMS_REACHED;
    case '08':
      return CART_ERRORS.HOTEL_MIX_FORBIDDEN;
    case '09':
      return CART_ERRORS.INCORRECT_SETTINGS;
    case '01':
    case '02':
      return CART_ERRORS.HOTEL_NOT_FOUND;
    default:
      return CART_ERRORS.OTHER_REASON;
  }
};
